/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Middle_School_Teaching25Inputs */

const en__field_enum_study_middle_school_teaching25 = /** @type {(inputs: _Field_Enum_Study_Middle_School_Teaching25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middle School Teaching`)
};

const de__field_enum_study_middle_school_teaching25 = /** @type {(inputs: _Field_Enum_Study_Middle_School_Teaching25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Haupt- und Realschulen`)
};

/**
* | output |
* | --- |
* | "Middle School Teaching" |
*
* @param {_Field_Enum_Study_Middle_School_Teaching25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_middle_school_teaching25 = /** @type {((inputs?: _Field_Enum_Study_Middle_School_Teaching25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Middle_School_Teaching25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_middle_school_teaching25(inputs)
	return de__field_enum_study_middle_school_teaching25(inputs)
});
export { _field_enum_study_middle_school_teaching25 as "_field_enum_STUDY_MIDDLE_SCHOOL_TEACHING" }